module.exports = '<svg width="28" height="32" viewBox="0 0 28 32"><path d="M26 6h-6V2c0-1.106-.696-2-1.8-2H9.8C8.696 0 8 .894 8 2v4H2C.894 6 0 6.894 0 8s.894 2 2 2h24c1.106 0 2-.894 2-2s-.894-2-2-2zM16 6h-4V4h4v2zM2 30c0 1.106.894 2 2 2h20c1.106 0 2-.894 2-2V13a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v17z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/trash-2.js
// module id = 1456
// module chunks = 14